import type { IconNode } from '../types';

/**
 * @name leaf
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEgMjBhMTAgMTAgMCAwMDEwLTEwIDI1LjkgMjUuOSAwIDAwLTEuMDQtNy4yODEgMSAxIDAgMDAtMS43NTUtLjMyNUMxNS44MzMgNS41IDEzIDUuNSA5LjggNi4xQTcgNyAwIDAwMTEgMjAiIC8+CiAgPHBhdGggZD0iTTIgMjFhNSA1IDAgMDEyLjkxMS00LjU0NEM3LjYxMyAxNS4yMTIgOC4zNTEgMTUuMjQgMTEgMTMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/leaf
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Leaf: IconNode = [
  [
    'path',
    {
      d: 'M11 20a10 10 0 0010-10 25.9 25.9 0 00-1.04-7.281 1 1 0 00-1.755-.325C15.833 5.5 13 5.5 9.8 6.1A7 7 0 0011 20',
    },
  ],
  ['path', { d: 'M2 21a5 5 0 012.911-4.544C7.613 15.212 8.351 15.24 11 13' }],
];

export default Leaf;
